import { render, staticRenderFns } from "./soundList.vue?vue&type=template&id=33384a80&scoped=true"
import script from "./soundList.vue?vue&type=script&lang=js"
export * from "./soundList.vue?vue&type=script&lang=js"
import style0 from "./soundList.vue?vue&type=style&index=0&id=33384a80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33384a80",
  null
  
)

export default component.exports